import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import cx from 'classnames';
import { withRouter } from 'react-router-dom';
import PublicRoutes from '../routes/PublicRoutes';

const PublicLayout = ({ match }) => {
  const themeOption = useSelector(state => state.themeOption);

  const { colorScheme } = themeOption;

  return (
    <>
      <div className={cx(`app-container app-theme-${colorScheme}`)}>
        <div className="app-main">
          <div className="app-main__outer">
            <PublicRoutes />
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(PublicLayout);
